import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ApiService } from '../../services/api.service';

@Component({
  selector: 'app-aon-soc',
  standalone: false,
  templateUrl: './aon-soc.component.html'
})
export class AonSocComponent implements OnInit {

  @Input() stepDetails: any;
  // @Output() routeConfig: EventEmitter<any> = new EventEmitter();
  @Output() IRA: EventEmitter<any> = new EventEmitter();
  @Output() routeConfig = new EventEmitter<any>();
  @Output() stepCompleted = new EventEmitter<void>();
  @Input() schemeType: any;
  @Input() step: any;
  @Input() proposalId: any;

 isEditorDisabled: boolean = false;
  payload: any;
  aonForm!: FormGroup;
  aonResponse: any; // ✅ Store API response
  isSubmitting = false;

  constructor(
    private fb: FormBuilder,
    private messageService: MessageService,
    private api: ApiService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    

    this.route.queryParams.subscribe((params: any) => {
      this.payload = {
        proposal_id: params['id'],
        proposal_name: params['name'],
        proposal_step: params['step']
      };

      this.initForm();
      this.getAonDetails(); // ✅ Call API on load
    });
  }

   ngAfterViewInit() {
    setTimeout(() => {
      if (this.stepDetails?.can_edit) {
         this.isEditorDisabled = false;
        this.aonForm.enable();
      } else {
         this.isEditorDisabled = true;
        this.aonForm.disable();
      }
    }, 3000);
  }
  goToNextStep() {
    this.stepCompleted.emit();
  }
  isAonOpen = true;

toggleAon() {
  this.isAonOpen = !this.isAonOpen;
}

  /* ================= FORM INIT ================= */
  initForm() {
    this.aonForm = this.fb.group({
      aon_date: ['', Validators.required],
      aon_qty: ['', Validators.required],
      aon_cost: ['', Validators.required]
    });

    if (!this.stepDetails?.can_edit) {
      this.aonForm.disable();
    }
  }

  /* ================= GET API ================= */
 getAonDetails() {
  const url = `/idex/aon-details/?proposal_step=${this.payload?.proposal_step}&proposal_step__proposal=${this.payload?.proposal_id}`;

  this.api.getAPI(url).subscribe({
    next: (res: any) => {

      console.log('GET AON RESPONSE:', res);

      if (res) {

        // 👉 Your API is returning object, not array
        this.aonResponse = res;

        this.aonForm.patchValue({
          aon_date: res.aon_date,
          aon_qty: res.aon_qty,
          aon_cost: res.aon_cost
        });
      }
    },
    error: (err) => {
      console.error('GET API Error:', err);
    }
  });
}

  /* ================= SAVE + ROUTE ================= */
onSaveAndRoute() {

  if (this.aonForm.invalid) {
    this.aonForm.markAllAsTouched();
    return;
  }

  // this.isSubmitting = true;

  const body = {
    aon_date: this.aonForm.value.aon_date,
    aon_qty: this.aonForm.value.aon_qty,
    aon_cost: this.aonForm.value.aon_cost,
    proposal_step: this.payload?.proposal_step
  };

  const id = this.aonResponse?.id;

  if (!id) {
    console.error('❌ AON ID not found');
    // this.isSubmitting = false;
    return;
  }

  this.api.putAPI(`/idex/aon-details/${id}/`, body).subscribe({
    next: (res: any) => {

      // this.isSubmitting = false;
      this.aonResponse = res;

      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: 'AON Details Updated Successfully'
      });

      // ✅ STEP MOVE HERE
      // this.stepCompleted.emit();

      // // OPTIONAL: if still need popup
      // this.routeConfig.emit({ isRouteConfig: true });
    },

    error: (err) => {
      // this.isSubmitting = false;

      console.error('❌ ERROR:', err);

      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Network/API Error'
      });
    }
  });
}
}